import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import impersonationService from '../services/impersonationService';

const ImpersonationBanner = () => {
    const [isImpersonating, setIsImpersonating] = useState(false);
    const [impersonatedUser, setImpersonatedUser] = useState(null);
    const [originalAdmin, setOriginalAdmin] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check initial impersonation state
        checkImpersonationState();

        // Subscribe to auth state changes
        const unsubscribe = impersonationService.onAuthStateChange((authState) => {
            setIsImpersonating(authState.isImpersonating);
            setImpersonatedUser(authState.impersonatedUser);
            setOriginalAdmin(authState.originalAdmin);
        });

        // Also check every second to ensure we catch changes
        const interval = setInterval(checkImpersonationState, 1000);

        // Cleanup subscription on unmount
        return () => {
            unsubscribe();
            clearInterval(interval);
        };
    }, []);

    const checkImpersonationState = () => {
        const isImpersonatingNow = impersonationService.isImpersonating();
        const impersonatedUserNow = impersonationService.getImpersonatedUser();
        const originalAdminNow = impersonationService.getOriginalAdmin();
        
        // Removed console.log to prevent infinite loop and improve performance
        
        setIsImpersonating(isImpersonatingNow);
        setImpersonatedUser(impersonatedUserNow);
        setOriginalAdmin(originalAdminNow);
    };

    const handleSwitchBack = async () => {
        setIsLoading(true);
        try {
            await impersonationService.stopImpersonation();
            // State will be updated via the auth state change listener
        } catch (error) {
            console.error('Failed to switch back:', error);
            // You might want to show a toast error message here
        } finally {
            setIsLoading(false);
        }
    };

    // Don't render anything if not impersonating
    if (!isImpersonating) {
        return null;
    }

    const bannerContent = (
        <div className="flex align-items-center justify-content-between w-full">
            <div className="flex align-items-center gap-3">
                <i className="pi pi-user-edit text-white text-xl"></i>
                <div className="flex flex-column">
                    <span className="text-white font-medium">
                        User Management View: <strong>{impersonatedUser?.name || 'Unknown User'}</strong>
                    </span>
                    {originalAdmin && (
                        <span className="text-white text-sm opacity-90">
                            Original admin: {originalAdmin.name}
                        </span>
                    )}
                </div>
            </div>
            
            <Button
                label={isLoading ? "Switching..." : "Switch Back to Admin"}
                icon={isLoading ? null : "pi pi-arrow-left"}
                onClick={handleSwitchBack}
                disabled={isLoading}
                className="p-button-warning p-button-sm"
                size="small"
            >
                {isLoading && <ProgressSpinner className="mr-2" style={{ width: '16px', height: '16px' }} />}
            </Button>
        </div>
    );

    return (
        <div className="impersonation-banner" style={{
            backgroundColor: '#ff6b35',
            padding: '0.75rem 1rem',
            borderRadius: '0',
            margin: '0',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
            {bannerContent}
        </div>
    );
};

export default ImpersonationBanner;